let isDragging = false;
let startPos = 0;
let currentTranslate = 0;
let prevTranslate = 0;
let animationID = 0;
let currentIndex = 0;

function lightboxModalOnTop() {
  document.getElementsByClassName('lightbox')[0].style.display = 'block';
  document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  document.getElementsByClassName('main-content')[0].style.display = 'none';
}

function loadImagesInModal(imageSources) {
  const lightbox = document.getElementById('slider-container');

  for (var i = 0; i < imageSources.length; i++) {
    lightbox.innerHTML += `<div class="slide"><img src="${imageSources[i]}" alt="" /></div>`;
  }

  lightbox.innerHTML += `<div class="slide bp-slider-cta-slide" style="background-image: url('${imageSources[0]}'); background-size: cover; background-position: center;"><div class="bp-slider-cta-slide__content"><h2>Interesse in dit bedrijfspand?</h2><button type="button" class="btn bp-slider-cta-slide__button" data-target="#contact-form-modal" data-toggle="modal">Neem contact op met de aanbieder</button></div></div>`;
}

function loadImagesInModalDesktop(imageSources) {
  document.getElementById('lightbox').innerHTML += `<button id="prevButton" class="prevButton"><span id="circle" class="circle"><span class="arrow leftArrow"></span></span></button><button id="nextButton" class="nextButton"><span id="circle" class="circle"><span class="arrow rightArrow"></span></span></button>`;
  const lightbox = document.getElementById('slider-container');

  for (var i = 0; i < imageSources.length; i++) {
    lightbox.innerHTML += `<div class="slide-desktop"><img src="${imageSources[i]}" alt="" /></div>`;
  }

  lightbox.innerHTML += `<div class="slide-desktop bp-slider-cta-slide" style="background-image: url('${imageSources[0]}'); background-size: cover; background-position: center;"><div class="bp-slider-cta-slide__content"><h2>Interesse in dit bedrijfspand?</h2><button type="button" class="btn bp-slider-cta-slide__button" data-target="#contact-form-modal" data-toggle="modal">Neem contact op met de aanbieder</button></div></div>`;
}

function touchSliderListeners() {
  const slider = document.querySelector('.slider-container');
  const slides = Array.from(document.querySelectorAll('.slide'));

  const lightboxEl = document.getElementById('lightbox');
  const closeButtons = lightboxEl.querySelectorAll('.adButton, .bp-slider-cta-slide__button');
  closeButtons.forEach((btn) => btn.addEventListener('click', closeSlideShow));

  slides.forEach((slide, index) => {
    const slideImage = slide.querySelector('img');
    if (slideImage) {
      slideImage.addEventListener('dragstart', (e) => e.preventDefault());
    }

    slide.addEventListener('touchstart', touchStart(index));
    slide.addEventListener('touchend', touchEnd);
    slide.addEventListener('touchmove', touchMove);
    slide.addEventListener('mousedown', touchStart);
    slide.addEventListener('mouseup', touchEnd);
    slide.addEventListener('mouseleave', touchEnd);
    slide.addEventListener('mousemove', touchMove);
  });

  function touchStart(index) {
    return function (event) {
      currentIndex = index;
      startPos = getPositionX(event);
      isDragging = true;

      animationID = requestAnimationFrame(animation);
      slider.classList.add('grabbing');
    };
  }

  function touchEnd() {
    isDragging = false;
    cancelAnimationFrame(animationID);

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -100 && currentIndex < slides.length - 1) {
      currentIndex += 1;
    }

    if (movedBy > 100 && currentIndex > 0) {
      currentIndex -= 1;
    }

    setPositionByIndex();
    slider.classList.remove('grabbing');
  }

  function touchMove(event) {
    if (isDragging) {
      const currentPosition = getPositionX(event);
      currentTranslate = prevTranslate + currentPosition - startPos;
    }
  }

  function getPositionX(event) {
    return (event.type.includes('mouse') ? event.pageX : event.touches[0].clientX);
  }

  function animation() {
    setSliderPosition();
    if (isDragging) requestAnimationFrame(animation);
  }

  function setSliderPosition() {
    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  function setPositionByIndex() {
    currentTranslate = currentIndex * -window.innerWidth;
    prevTranslate = currentTranslate;
    setSliderPosition();
  }

  function closeSlideShow() {
    isDragging = false;
    startPos = 0;
    currentTranslate = 0;
    prevTranslate = 0;
    animationID = 0;
    currentIndex = 0;

    setSliderPosition();
    document.querySelector('.slider-container').innerHTML = '';
    document.getElementsByClassName('lightbox')[0].style.display = 'none';
    document.getElementsByTagName('html')[0].style.overflow = 'visible';
    document.getElementsByClassName('main-content')[0].style.display = 'block';

    slides.forEach((slide, index) => {
      const slideImage = slide.querySelector('img');
      if (slideImage) {
        slideImage.removeEventListener('dragstart', (e) => e.preventDefault());
      }

      slide.removeEventListener('touchstart', touchStart(index));
      slide.removeEventListener('touchend', touchEnd);
      slide.removeEventListener('touchmove', touchMove);
      slide.removeEventListener('mousedown', touchStart);
      slide.removeEventListener('mouseup', touchEnd);
      slide.removeEventListener('mouseleave', touchEnd);
      slide.removeEventListener('mousemove', touchMove);
    });

    closeButtons.forEach((btn) => btn.removeEventListener('click', closeSlideShow));
  }
}

function desktopSliderListener() {
  const slider = document.querySelector('.slider-container');
  const slides = Array.from(document.querySelectorAll('.slide-desktop'));

  const lightboxEl = document.getElementById('lightbox');
  const closeButtons = lightboxEl.querySelectorAll('.adButton, .bp-slider-cta-slide__button');
  closeButtons.forEach((btn) => btn.addEventListener('click', closeSlideShow));

  const leftButton = document.getElementById('prevButton');
  const rightButton = document.getElementById('nextButton');
  leftButton.addEventListener('click', leftHandler);
  rightButton.addEventListener('click', rightHandler);
  document.addEventListener('keydown', keyHandler);

  function keyHandler(event) {
    const callback = {
      'ArrowLeft': leftHandler,
      'ArrowRight': rightHandler,
      'Escape': closeSlideShow,
    }[event.key];
    callback?.();
  }

  function leftHandler() {
    if (currentIndex) {
      currentIndex -= 1;
      setPositionByIndex();
    }

    if (currentIndex) {
      leftButton.style.opacity = '100%';
      rightButton.style.opacity = '100%';
    } else {
      leftButton.style.opacity = '0%';
    }
  }

  function rightHandler() {
    if (currentIndex < slides.length - 1) {
      currentIndex += 1;
      setPositionByIndex();
    }

    if (currentIndex != slides.length - 1) {
      rightButton.style.opacity = '100%';
      leftButton.style.opacity = '100%';
    } else {
      rightButton.style.opacity = '0%';
    }
  }

  function setSliderPosition() {
    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  function setPositionByIndex() {
    currentTranslate = currentIndex * -window.innerWidth;
    setSliderPosition();
  }

  function closeSlideShow() {
    currentTranslate = 0;
    currentIndex = 0;
    setSliderPosition();

    document.querySelector('.lightbox').innerHTML = `<button class="adButton" type="button">x</button><div id="slider-container" class="slider-container"></div>`;
    document.getElementsByClassName('lightbox')[0].style.display = 'none';
    document.getElementsByTagName('html')[0].style.overflow = 'visible';
    document.getElementsByClassName('main-content')[0].style.display = 'block';

    document.removeEventListener('keydown', keyHandler);
    leftButton.removeEventListener('click', leftHandler);
    rightButton.removeEventListener('click', rightHandler);
    closeButtons.forEach((btn) => btn.removeEventListener('click', closeSlideShow));
  }
}

function touchSlider(photovideos) {
  const imageSources = JSON.parse(photovideos);
  lightboxModalOnTop();
  loadImagesInModal(imageSources);
  touchSliderListeners();
}

function desktopSlider(photovideos) {
  const imageSources = JSON.parse(photovideos);
  lightboxModalOnTop();
  loadImagesInModalDesktop(imageSources);
  desktopSliderListener();
}

window.touchSlider = touchSlider;
window.desktopSlider = desktopSlider;
